import type { PredicateValue } from '../api/types';

/** Условие в том виде, в каком его отдаёт и принимает сервер: строгая запись и её описание */
type StoredPredicate = { dsl?: string | null; dslHuman?: string | null };

/**
 * Сохранённое условие в значение поля формы; без условия — `undefined`.
 *
 * Пустое описание становится пустой строкой, а не `null`: поле ввода условия сверяет
 * описание с набранным текстом, и `null` при пустом поле приняло бы за правку.
 */
export const toPredicateValue = (predicate: StoredPredicate | null | undefined): PredicateValue | undefined =>
  predicate ? { dsl: predicate.dsl ?? '', dslHuman: predicate.dslHuman ?? '' } : undefined;

/**
 * Условие в виде тела запроса: строгая запись и её описание без краевых пробелов.
 * Пустая запись — условия нет (`null`); пустое описание уходит `null`.
 */
export const toPredicatePayload = (value: StoredPredicate | null | undefined) => {
  const dsl = value?.dsl?.trim();
  const dslHuman = value?.dslHuman?.trim();
  return dsl ? { dsl, dslHuman: dslHuman || null } : null;
};
